import React from 'react'
import { chooseWallpaper, translate } from "../../utils/useful";
import Responsive from '../../components/Responsive';
import CustomLoader from '../../components/CustomLoader';
import StagesManager from '../../components/StagesManager';


class VoiceCallsHistory extends React.Component {
    state = {
        voicecalls: [
            { icon: "/assets/icons/rooms/rejected.svg", color: "#FF3B30", name: "Reza Salek", date: "Today, 9:55 AM" },
            { icon: "/assets/icons/rooms/outcome.svg", color: "#444", name: "Nastaran Javid", date: "Yesterday, 5:25 PM" },
            { icon: "/assets/icons/rooms/income.svg", color: "#444", name: "Pedram Pezhman", date: "3/5/23, 10:55 AM" },
            { icon: "/assets/icons/rooms/outcome.svg", color: "#444", name: "Nastaran Javid", date: "Yesterday, 5:25 PM" },
            { icon: "/assets/icons/rooms/outcome.svg", color: "#444", name: "Nastaran Javid", date: "Yesterday, 5:25 PM" },
            { icon: "/assets/icons/rooms/rejected.svg", color: "#FF3B30", name: "Reza Salek", date: "Today, 9:55 AM" },
            { icon: "/assets/icons/rooms/income.svg", color: "#444", name: "Pedram Pezhman", date: "3/5/23, 10:55 AM" },
            { icon: "/assets/icons/rooms/income.svg", color: "#444", name: "Pedram Pezhman", date: "3/5/23, 10:55 AM" },
            { icon: "/assets/icons/rooms/rejected.svg", color: "#FF3B30", name: "Reza Salek", date: "Today, 9:55 AM" },
            { icon: "/assets/icons/rooms/outcome.svg", color: "#444", name: "Nastaran Javid", date: "Yesterday, 5:25 PM" },
            { icon: "/assets/icons/rooms/rejected.svg", color: "#FF3B30", name: "Reza Salek", date: "Today, 9:55 AM" },
            { icon: "/assets/icons/rooms/income.svg", color: "#444", name: "Pedram Pezhman", date: "3/5/23, 10:55 AM" },
        ],
        isLoader: false
    }

    componentDidMount() {

    }

    componentWillUnmount() {
    }





    render() {
        return (

            <div className='flexcc' style={{}}>
                <div className=' w-100 scroll-no-scrollbar'>
                    <div className='mt-3'>
                        {this.state.voicecalls.map((prop, index) => {
                            return (
                                <div className='bb-gray hover-gray2 mx-3 px-2 br-5'>
                                    <button className='flexcb w-100 py-2'>
                                        <div className='flexc'>
                                            <img className='mrd-2' src={prop.icon} />
                                            <p style={{ color: prop.color }}>{prop.name}</p>
                                        </div>
                                        <div className='prd-2 font-size-10' style={{ color: prop.color }}>{prop.date}</div>
                                    </button>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

        )
    }
}

export default VoiceCallsHistory;